import { useTheme } from '@mui/material';
const useNavigationStyles = () => {
    const theme = useTheme();
    return {
        navigationTileStyles: {
            display: 'flex',
            flexDirection: 'row',
            flex: 1,
            justifyContent: 'space-between',
            alignItems: 'center',
            p: 1.5,
            alignSelf: 'stretch',
            borderRadius: 1,
            cursor: 'pointer',
            width: '100%'
        },
        nameContainerStyles: {
            display: 'flex',
            flex: 'row',
            alignItems: 'center',
            gap: 2
        }
    };
};
export default useNavigationStyles;
